import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: any = {
    studentClassModuleList: [],
    loading: false,
    subModuleTree: [],
    subModuleDetail: [],
    sesstionSubmoduleResult: {},
    studentWrongQuestionResult: {},
    practiceEnrollSuccess: 0,
    practiceEnrollLoading: false,
    currentQuestionList: [],
    currentModulePractice: null,
    pdfList:null,
    loadingPdfList:null,
    emgInsertResultLoading: false,
    emgInsertResultSuccess: 0,
    emgInsertResultData: null,
    emgInsertResultOutcome: null,
};

const studentPracticeSlice = createSlice({
    name: 'studentPractice',
    initialState,
    reducers: {
        setLoading(state, action) {
            state.loading = action.payload;
        },
        setStudentClassModuleList(state, action) {
            state.studentClassModuleList = action.payload;
        },
        setSubModuleTree(state, action) {
            state.subModuleTree = action.payload
        },
        setSubModuleDetail(state, action) {
            state.subModuleDetail = action.payload
        },
        setPdfList(state, action) {
            state.pdfList = action.payload
        },
        setLoadingPdfList(state, action) {
            state.loadingPdfList = action.payload
        },
        setSesstionSubmoduleResult(state, action) {
            state.sesstionSubmoduleResult = action.payload
        },
        setStudentWrongQuestionsResult(state, action) {
            state.studentWrongQuestionResult = action.payload
        },
        setPracticeEnrollSuccess(state, action) {
            state.practiceEnrollSuccess = action.payload
        },
        setPracticeEnrollLoading(state, action) {
            state.practiceEnrollLoading = action.payload
        },
        setEmgInsertResultLoading(state, action) {
            state.emgInsertResultLoading = action.payload
        },
        setEmgInsertResultSuccess(state, action) {
            state.emgInsertResultSuccess = action.payload
        },
        setEmgInsertResultData(state, action) {
            state.emgInsertResultData = action.payload
        },
        setEmgInsertResultOutcome(state, action) {
            state.emgInsertResultOutcome = action.payload
        },
        clearEmgInsertResultOutcome(state) {
            state.emgInsertResultOutcome = null
        },
        resetStudentPracticeData(state) {
            state.studentClassModuleList = initialState.studentClassModuleList,
            state.subModuleTree = initialState.subModuleTree,
            state.subModuleDetail = initialState.subModuleDetail,
            state.sesstionSubmoduleResult = initialState.sesstionSubmoduleResult,
            state.examResult = initialState.examResult,
            state.studentWrongQuestionResult = initialState.studentWrongQuestionResult,
            state.practiceEnrollSuccess = initialState.practiceEnrollSuccess,
            state.practiceEnrollLoading = initialState.practiceEnrollLoading,
            state.emgInsertResultLoading = initialState.emgInsertResultLoading,
            state.emgInsertResultSuccess = initialState.emgInsertResultSuccess,
            state.emgInsertResultData = initialState.emgInsertResultData
            state.emgInsertResultOutcome = initialState.emgInsertResultOutcome
        },
        resetPracticeEnrollData(state) {
            state.practiceEnrollSuccess = initialState.practiceEnrollSuccess,
            state.practiceEnrollLoading = initialState.practiceEnrollLoading
        },
        resetEmgInsertResultData(state) {
            state.emgInsertResultLoading = initialState.emgInsertResultLoading,
            state.emgInsertResultSuccess = initialState.emgInsertResultSuccess,
            state.emgInsertResultData = initialState.emgInsertResultData
            state.emgInsertResultOutcome = initialState.emgInsertResultOutcome
        },
        setCurrentQuestionList(state, action) {
            state.currentQuestionList = action.payload
        },
        setCurrentModulePractice(state, action) {
            state.currentModulePractice = action.payload
        }
    },
});

export const {
    setLoading,
    setStudentClassModuleList,
    setSubModuleTree,
    setSubModuleDetail,
    resetStudentPracticeData,
    setSesstionSubmoduleResult,
    setStudentWrongQuestionsResult,
    setPracticeEnrollSuccess,
    setPracticeEnrollLoading,
    resetPracticeEnrollData,
    setCurrentQuestionList,
    setCurrentModulePractice,
    setPdfList,
    setLoadingPdfList,
    setEmgInsertResultLoading,
    setEmgInsertResultSuccess,
    setEmgInsertResultData,
    setEmgInsertResultOutcome,
    clearEmgInsertResultOutcome,
    resetEmgInsertResultData,
} = studentPracticeSlice.actions;

export default studentPracticeSlice.reducer;